module.exports = __webpack_public_path__ + "static/media/ht.a691e42f.svg";